import { useState } from "react";
import { useDispatch } from "react-redux";
import { AlmacenesEmpleadoSelect } from "./reusable/AlmacenesEmpleadoSelect";
import { productosInventarioStartLoading } from "../../actions/inventario";
import { Col, Form, Input, Row, Space, Tooltip } from "antd";
import { SearchFormUi } from "../ui/SearchFormUi";
import { FilterBtn, SearchBtn } from "../ui";
const initialValues = { almacen: null, search: null };

export const InventarioSeachForm = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [moreSearch, setMoreSearch] = useState(false);

  const handleSubmit = (value) => {
    localStorage.setItem("SearhFormTable", JSON.stringify(value));
    dispatch(productosInventarioStartLoading(value));
  };
  const handleMoreSearch = () => {
    setMoreSearch(!moreSearch);
    if (!moreSearch) form.setFieldValue("search", null);
  };

  return (
    <SearchFormUi
      name="FormSearchInventario"
      form={form}
      autoComplete="off"
      initialValues={initialValues}
      handleSubmit={handleSubmit}
    >
      {moreSearch && (
        <Row gutter={[8, 8]}>
          <Col xs={24} sm={24} md={24} lg={16} xl={12} xxl={12}>
            <Form.Item name="search" label="Nombre">
              <Input placeholder="Buscar item por nombre o sku" allowClear />
            </Form.Item>
          </Col>
        </Row>
      )}

      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={24} lg={16} xl={12} xxl={12}>
          <Form.Item name="almacen" label="Almacén">
            <AlmacenesEmpleadoSelect placeholder="[-TODOS-]" allowClear />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8} md={12} lg={6} xl={6}>
          <Form.Item>
            <Space wrap>
              <SearchBtn htmlType="submit" />
              <Tooltip title="Más filtros">
                <FilterBtn displayText={false} onClick={handleMoreSearch} />
              </Tooltip>
            </Space>
          </Form.Item>
        </Col>
      </Row>
    </SearchFormUi>
  );
};
